<div class="container">
  <div class="row">
    <div class="card col-md-8 offset-md-2">
      <div class="card-header">
        <h2>Logowanie</h2>
      </div>
      <div class="card-body">
        <div *ngIf="sessionExpired && !authenticated" class="alert alert-info" role="alert">
          <strong>Twoja sesja wygasła.</strong> Zaloguj sie ponownie.
        </div>
        <div *ngIf="casUnavaliable && !authenticated" class="alert alert-warning" role="alert">
          Usługa uwierzytelniania USOS PW jest w tej chwili niedostępna.
          <br />
          Prosimy spróbować ponownie później lub
          zalogować się przy użyciu adresu email i hasła.
          <br />
          <br />
          Jeśli nie pamiętasz hasła możesz je <a href="#" (click)="renewPasswordButton()">zresetować</a>.
          <br />
          Prosimy zwrócić uwagę, że konto studenckie założone przy użyciu USOS PW może być powiązane z adresem email w
          systemie USOS.
        </div>
        <div *ngIf="authenticated===false">
          <div [hidden]="!error" class="alert alert-danger">{{error}}</div>
          <form #loginForm="ngForm">
            <div class="form-group">
              <label for="username">Nazwa użytkownika</label>
              <input #username="ngModel" type="text" class="form-control" id="username" name="username" required
                [(ngModel)]="credentials.username" />
              <div *ngIf="username.invalid && (username.dirty || username.touched)" class="text-danger">
                Nazwa użytkownika jest wymagana
              </div>
            </div>
            <div class="form-group">
              <label for="password">Hasło</label>
              <input type="password" class="form-control" id="password" name="password" required
                [(ngModel)]="credentials.password" #password="ngModel" />
              <div *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">
                Hasło jest wymagane
              </div>
            </div>
            <a href="#" class="btn btn-link" (click)="renewPasswordButton()">Nie pamiętasz hasła?</a>
            <button type="submit" class="btn btn-success float-right" (click)="login()">Zaloguj się</button>
          </form>
          <div *ngIf="logowanieUsos">
            <hr />
            <button (click)="toggleCzyPokazacUsos()" class="btn btn-info">Jestem studentem</button>
          </div>
        </div>
        <div *ngIf="authenticated ===true">
          <p>
            Jesteś zalogowany.

          </p>
          <button class="btn btn-success" (click)="logout()">Wyloguj się</button>
        </div>

      </div>
    </div>
    <div class="offset-md-2 col-sm-8 usos-login-background" *ngIf="pokazUsos()">
      <div class="usos-login-container">
        <h1>Logowanie studentów w systemie USOS?</h1>
        Możesz zalogować się do naszej aplikacji, korzystając ze swojego konta w systemie USOS.
        <div style="margin: 15px auto">
          <a class="btn btn-info" href="https://power.mini.pw.edu.pl/api/cas/secured">Zaloguj przez
            USOS</a>
        </div>
        <img src="/shared-assets/images/usos-web.png" class="img-fluid img-usos-login">
        <p>
          Osoby mające konto w systemie USOS mają już założone konto w sytemie zeszyt.online.
        </p>
      </div>
    </div>
  </div>
</div>
